var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96116 1.66797C5.38783 1.66797 1.66699 5.4063 1.66699 10.0013C1.66699 14.5963 5.40533 18.3346 10.0003 18.3346C14.5953 18.3346 18.3337 14.5963 18.3337 10.0013C18.3337 5.4063 14.5778 1.66797 9.96116 1.66797ZM10.0003 16.668C6.32449 16.668 3.33366 13.6771 3.33366 10.0013C3.33366 6.32547 6.30616 3.33464 9.96116 3.33464C13.6595 3.33464 16.667 6.32547 16.667 10.0013C16.667 13.6771 13.6762 16.668 10.0003 16.668Z",
    fill: "#60A5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 5.83203H10.8337V11.6654H9.16699V5.83203ZM9.16699 12.4987H10.8337V14.1654H9.16699V12.4987Z",
    fill: "#60A5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxErrorCircle);
export default __webpack_public_path__ + "static/media/bx-error-circle.6b698f564d7c9e79b7a51f3033c6ed74.svg";
export { ForwardRef as ReactComponent };